// Letris — definiciones de modos y desbloqueables (boosts/temas)

export const MODES = {
  classic: {
    id: 'classic',
    name: 'CLÁSICO',
    subtitle: 'Fases · bosses · builds',
    desc: 'Modo principal. Sube de nivel, supera fases, derrota bosses y construye tu mazo Letris.',
    config: { timeLimit: null, allowGameOver: true, gravityScales: true },
  },
  zen: {
    id: 'zen',
    name: 'ZEN',
    subtitle: 'Sin techo · sin presión',
    desc: 'Como el clásico pero sin la línea de peligro. Practica sin riesgo de game over.',
    config: { timeLimit: null, allowGameOver: false, gravityScales: true },
  },
  diario: {
    id: 'diario',
    name: 'DIARIO',
    subtitle: 'Pack del día',
    desc: 'Encuentra el pack de palabras del día. Las letras que caen permiten formarlas. Una entrada diaria.',
    config: { timeLimit: null, allowGameOver: false, gravityScales: true, dailyTargets: true },
    seedFromDate: true,
  },
  duelo: {
    id: 'duelo',
    name: 'DUELO',
    subtitle: '1v1 online',
    desc: 'Reta a otro jugador. Forma palabras → envía basura al rival. Mismo seed = igualdad de letras.',
    config: { timeLimit: null, allowGameOver: true, gravityScales: true, duelMode: true },
    requiresLobby: true,
  },
};

export const UNLOCKS = {
  // ====== TEMAS ======
  'theme-default': { id: 'theme-default', kind: 'theme', name: 'NEÓN DEFAULT', cost: 0, owned: true,
    desc: 'La identidad clásica de Letris.',
    palette: null },
  'theme-amanecer': { id: 'theme-amanecer', kind: 'theme', name: 'AMANECER', cost: 200,
    desc: 'Interfaz cálida: coral, sol y tinta oscura.',
    palette: ['#F4A261', '#E76F51', '#264653', '#E9C46A'] },
  'theme-bosque':   { id: 'theme-bosque', kind: 'theme', name: 'BOSQUE', cost: 200,
    desc: 'Verdes apagados y tablero más orgánico.',
    palette: ['#588157', '#A3B18A', '#3A5A40', '#DAD7CD'] },
  'theme-vapor':    { id: 'theme-vapor', kind: 'theme', name: 'VAPOR', cost: 350,
    desc: 'Rosa eléctrico, violeta y acentos amarillos.',
    palette: ['#FF6AC1', '#9D4EDD', '#5A189A', '#FFD60A'] },
  'theme-oceano':   { id: 'theme-oceano', kind: 'theme', name: 'OCÉANO', cost: 300,
    desc: 'Azules profundos con acento espuma.',
    palette: ['#2EC4B6', '#0B7285', '#102A43', '#B5EAEA'] },
  'theme-arcade':   { id: 'theme-arcade', kind: 'theme', name: 'ARCADE ROJO', cost: 450,
    desc: 'Más contraste, rojo máquina y amarillo premio.',
    palette: ['#FFCA3A', '#FF595E', '#1B1B1F', '#8AC926'] },

  // ====== BOOSTS ======
  'boost-time':     { id: 'boost-time', kind: 'boost', name: '+30s', cost: 80,
    desc: 'Añade 30s al cronómetro al empezar (sólo modos con tiempo).',
    apply: (cfg) => { if (cfg.timeLimit) cfg.timeLimit += 30; } },
  'boost-clear':    { id: 'boost-clear', kind: 'boost', name: 'BASE LIMPIA', cost: 120,
    desc: 'Comienza cada run con más margen antes del primer techo.',
    apply: (cfg) => { cfg.startGrace = (cfg.startGrace || 0) + 24; } },
  'boost-l2-seed':  { id: 'boost-l2-seed', kind: 'boost', name: 'SIEMBRA L2', cost: 150,
    desc: 'Las 3 primeras letras nacen ya en nivel 1.',
    apply: (cfg) => { cfg.seedL2 = 3; } },
  'boost-vowels':   { id: 'boost-vowels', kind: 'boost', name: 'ARRANQUE VOCAL', cost: 180,
    desc: 'Las 4 primeras piezas tienen más vocales.',
    apply: (cfg) => { cfg.startVowels = (cfg.startVowels || 0) + 4; } },
  'boost-boss-ward': { id: 'boost-boss-ward', kind: 'boost', name: 'TALISMÁN BOSS', cost: 260,
    desc: 'Los bosses tardan más en lanzar patrones.',
    apply: (cfg) => { cfg.bossPatternDelay = (cfg.bossPatternDelay || 0) + 4; } },

  // ====== CARTAS PERMANENTES ======
  'card-rare-x2':   { id: 'card-rare-x2', kind: 'card', name: 'LETRAS RARAS ×2', cost: 400,
    desc: 'X, Z, K, W, Q, Ñ valen el doble en todas las partidas.',
    apply: (cfg) => { cfg.rareMultiplier = 2; } },
  'card-long-bonus': { id: 'card-long-bonus', kind: 'card', name: 'BONUS LARGAS', cost: 350,
    desc: 'Palabras de 6+ letras: +50% puntos.',
    apply: (cfg) => { cfg.longBonus = 1.5; } },
  'card-fast-fall': { id: 'card-fast-fall', kind: 'card', name: 'CAÍDA RÁPIDA', cost: 250,
    desc: 'Velocidad inicial +20%. Sólo para valientes.',
    apply: (cfg) => { cfg.fastFall = true; } },
  'card-letris-slot': { id: 'card-letris-slot', kind: 'card', name: 'BOLSILLO EXTRA', cost: 800,
    desc: '+1 slot Letris (max 4 cards activas).',
    apply: (cfg) => { cfg.letrisExtraSlot = (cfg.letrisExtraSlot || 0) + 1; } },
  'card-boss-slayer': { id: 'card-boss-slayer', kind: 'card', name: 'MATABOSSES', cost: 650,
    desc: '+25% daño a bosses.',
    apply: (cfg) => { cfg.bossDamageMul = (cfg.bossDamageMul || 1) * 1.25; } },
  'card-mission-pay': { id: 'card-mission-pay', kind: 'card', name: 'CONTRATISTA', cost: 520,
    desc: 'Las misiones dan +50% coins.',
    apply: (cfg) => { cfg.missionCoinMul = (cfg.missionCoinMul || 1) * 1.5; } },
  'card-draft-luck': { id: 'card-draft-luck', kind: 'card', name: 'SUERTE DRAFT', cost: 700,
    desc: 'Los drafts de nivel tienen más probabilidad de raras.',
    apply: (cfg) => { cfg.draftLuck = (cfg.draftLuck || 0) + 1; } },
};

// Coins ganados por palabra: 1 coin por cada 35 pts.
export const COINS_PER_POINT = 1 / 35;

// ====== LETRIS (Balatro-style cards) ======
// Coste base (lvl 1). Engine escala con `letrisCostFor(rarity, level)` × (1 + (level-1)*0.7)
export const LETRIS_RARITY = {
  common:    { weight: 60, cost: 80,   glow: '#888888',  label: 'COMÚN' },
  uncommon:  { weight: 25, cost: 220,  glow: '#06D6A0',  label: 'INUSUAL' },
  rare:      { weight: 12, cost: 550,  glow: '#FFD166',  label: 'RARA' },
  legendary: { weight: 3,  cost: 1500, glow: '#EF476F',  label: 'LEGENDARIA' },
};
export function letrisCostFor(rarity, level) {
  const base = LETRIS_RARITY[rarity].cost;
  return Math.round(base * (1 + (level - 1) * 0.7));
}
export const LETRIS_MAX_SLOTS = 3;
const VOWELS = 'AEIOU';
const RARES  = 'XZKJQÑW';

// ====== FASES / CAMPAÑA ENDLESS ======
// Cada fase dura 5 niveles. El quinto nivel invoca boss y aplica reglas más agresivas.
export const PHASES = [
  {
    id: 'foundry',
    name: 'FUNDICIÓN',
    subtitle: 'Fusiones limpias',
    fromLevel: 1,
    color: '#00A896',
    rule: 'Las fusiones sostienen la partida.',
    specialWeights: { mystery: 58, bonus: 30, ice: 8, bomb: 4 },
    intervalMul: 1.1,
    dangerMul: 0.95,
  },
  {
    id: 'archive',
    name: 'ARCHIVO',
    subtitle: 'Palabras largas',
    fromLevel: 6,
    color: '#FFD166',
    rule: 'Las palabras de 5+ letras dan +15% de daño a bosses.',
    specialWeights: { mystery: 46, bonus: 26, ice: 16, bomb: 12 },
    intervalMul: 1,
    dangerMul: 1.05,
    longDamageMul: 1.15,
  },
  {
    id: 'glacier',
    name: 'GLACIAR',
    subtitle: 'Hielo y bloqueo',
    fromLevel: 11,
    color: '#6EE7F9',
    rule: 'Aparece más hielo; usar tiles L2+ lo rompe más rápido.',
    specialWeights: { mystery: 36, bonus: 24, ice: 28, bomb: 12 },
    intervalMul: 0.92,
    dangerMul: 1.12,
  },
  {
    id: 'reactor',
    name: 'REACTOR',
    subtitle: 'Bombas bajo presión',
    fromLevel: 16,
    color: '#EF476F',
    rule: 'Más bombas; las palabras con raras dan más daño.',
    specialWeights: { mystery: 34, bonus: 22, ice: 16, bomb: 28 },
    intervalMul: 0.86,
    dangerMul: 1.18,
    rareDamageMul: 1.25,
  },
  {
    id: 'singularity',
    name: 'SINGULARIDAD',
    subtitle: 'Cascadas finales',
    fromLevel: 21,
    color: '#9B5DE5',
    rule: 'Todo aparece antes; las cascadas son la vía de escape.',
    specialWeights: { mystery: 30, bonus: 24, ice: 22, bomb: 24 },
    intervalMul: 0.78,
    dangerMul: 1.25,
    cascadeDamageMul: 1.35,
  },
];

export const BOSSES = [
  {
    id: 'censor',
    name: 'EL CENSOR',
    icon: '▓',
    color: '#EF476F',
    hp: 42,
    pattern: 'blockers',
    desc: 'Bloquea casillas. Palabras de 5+ le hacen más daño.',
  },
  {
    id: 'archivist',
    name: 'EL ARCHIVISTA',
    icon: 'A',
    color: '#FFD166',
    hp: 58,
    pattern: 'ice',
    desc: 'Congela letras. Usa fusiones para golpear fuerte.',
  },
  {
    id: 'reactor',
    name: 'EL REACTOR',
    icon: '✸',
    color: '#F15BB5',
    hp: 72,
    pattern: 'bombs',
    desc: 'Si tardas, llena el tablero de bombas.',
  },
  {
    id: 'lexicon',
    name: 'LETRIS PRIMORDIAL',
    icon: '✦',
    color: '#C6F432',
    hp: 92,
    pattern: 'mixed',
    desc: 'Resiste todo salvo palabras largas, raras y cascadas.',
  },
];

export const MISSION_POOL = [
  { id: 'long4', kind: 'longWords', target: 2, len: 4, label: '2 palabras de 4+', reward: { coins: 35, grace: 8 } },
  { id: 'long5', kind: 'longWords', target: 1, len: 5, label: '1 palabra de 5+', reward: { coins: 45, grace: 10 } },
  { id: 'fusion2', kind: 'fusionWords', target: 2, label: '2 palabras con tile L2+', reward: { coins: 50, clearRows: 1 } },
  { id: 'rare1', kind: 'rareLetters', target: 1, label: 'usa 1 letra rara', reward: { coins: 55, grace: 12 } },
  { id: 'letters18', kind: 'totalLetters', target: 18, label: 'limpia 18 letras', reward: { coins: 45, clearRows: 1 } },
  { id: 'cascade1', kind: 'cascades', target: 1, label: 'provoca 1 cascada', reward: { coins: 70, grace: 16 } },
];

// Cada Letris define hooks que el engine lee en puntos de integración:
//   scoreHook(ctx)  → multiplicador (1.0 = sin cambio) o modificador aditivo
//   coinHook(ctx)   → bonus pts coin (raw flat o mul, según campo)
//   graceHook(ctx)  → segundos extra de grace
//   gravityMul()    → multiplicador de gravedad (1.0 = sin cambio)
//   dangerMul()     → multiplicador velocidad descenso danger line
//   dropMul(ctx)    → multiplicador prob drop de otro Letris
// ctx.word, ctx.tiles, ctx.basePts, ctx.intensity, etc.
export const LETRIS_POOL = [
  // ===== COMUNES =====
  { id: 'vocal-fan', rarity: 'common', name: 'AMIGO VOCAL', icon: 'AE', color: '#06D6A0',
    desc: 'Vocales +2 pts cada una',
    scoreFlat: (ctx) => [...ctx.word].filter(c => VOWELS.includes(c)).length * 2 },

  { id: 'tres-letras', rarity: 'common', name: 'TRIPLETA', icon: '3', color: '#9B5DE5',
    desc: 'Palabras de 3 letras +25% pts',
    scoreMul: (ctx) => ctx.word.length === 3 ? 1.25 : 1 },

  { id: 'coin-bonus', rarity: 'common', name: 'PROPINA', icon: '◈', color: '#FFD166',
    desc: '+1 coin extra por palabra',
    coinFlat: () => 1 },

  { id: 'grace-bonus', rarity: 'common', name: 'RESPIRO', icon: '⏳', color: '#06D6A0',
    desc: '+2s grace extra por palabra',
    graceFlat: () => 2 },

  { id: 'level-up-bonus', rarity: 'common', name: 'ALQUIMISTA', icon: '↑', color: '#F4A261',
    desc: 'Tiles L2+ valen +30% pts',
    scoreMul: (ctx) => {
      const hasFusion = ctx.tiles.some(t => t.level >= 2);
      return hasFusion ? 1.3 : 1;
    }},

  // ===== INUSUALES =====
  { id: 'rare-hunter', rarity: 'uncommon', name: 'CAZADOR RARO', icon: '★', color: '#C6F432',
    desc: 'Letras X/Z/K/J/Ñ ×2.5 / vocales ×0.8',
    scoreMul: (ctx) => {
      const rares = [...ctx.word].filter(c => RARES.includes(c)).length;
      const vws = [...ctx.word].filter(c => VOWELS.includes(c)).length;
      const len = ctx.word.length;
      const rareBoost = rares > 0 ? 1 + (rares / len) * 1.5 : 1;
      const vowelPenalty = vws > 0 ? 1 - (vws / len) * 0.2 : 1;
      return rareBoost * vowelPenalty;
    }},

  { id: 'speed-demon', rarity: 'uncommon', name: 'DEMONIO VELOZ', icon: '⚡', color: '#EF476F',
    desc: 'Pts +30% / gravedad +20%',
    scoreMul: () => 1.3,
    gravityMul: () => 0.83 },

  { id: 'hoarder', rarity: 'uncommon', name: 'AVARO', icon: '◈', color: '#F4A261',
    desc: '+1 coin/palabra / pts −10%',
    coinFlat: () => 1,
    scoreMul: () => 0.9 },

  { id: 'precision', rarity: 'uncommon', name: 'PRECISIÓN', icon: '◎', color: '#9B5DE5',
    desc: '5+ letras ×2 / 3 letras ×0',
    scoreMul: (ctx) => {
      if (ctx.word.length === 3) return 0;
      if (ctx.word.length >= 5) return 2;
      return 1;
    }},

  { id: 'combo-stack', rarity: 'uncommon', name: 'CADENISTA', icon: '↻', color: '#06D6A0',
    desc: 'Palabras consecutivas +10% acum (reset 4s)',
    scoreMul: (ctx) => {
      const stack = ctx.state._comboStack || 0;
      return 1 + stack * 0.1;
    }},

  // ===== RARAS =====
  { id: 'glass-cannon', rarity: 'rare', name: 'CRISTAL', icon: '◆', color: '#EF476F',
    desc: 'Pts ×1.5 / danger desciende ×1.5',
    scoreMul: () => 1.5,
    dangerMul: () => 1.5 },

  { id: 'zen-master', rarity: 'rare', name: 'MAESTRO ZEN', icon: '☯', color: '#06D6A0',
    desc: 'Gravedad ×0.7 / no obtienes Letris drops',
    gravityMul: () => 0.7,
    dropMul: () => 0 },

  { id: 'gambler', rarity: 'rare', name: 'CASINO', icon: '?', color: '#FFD166',
    desc: '50% ×2 pts, 50% ×0.5',
    scoreMul: () => Math.random() < 0.5 ? 2 : 0.5 },

  { id: 'rage', rarity: 'rare', name: 'FURIA', icon: '!!', color: '#EF476F',
    desc: 'Intensity 7+: ×2 pts / Intensity <4: ×0.5',
    scoreMul: (ctx) => {
      if (ctx.intensity >= 7) return 2;
      if (ctx.intensity < 4) return 0.5;
      return 1;
    }},

  // ===== LEGENDARIAS =====
  { id: 'letris-itself', rarity: 'legendary', name: 'LETRIS', icon: '✦', color: '#C6F432',
    desc: 'Forma "LETRIS" → ×10 pts + 30s grace + 50 coins',
    scoreMul: (ctx) => ctx.word === 'LETRIS' ? 10 : 1,
    graceFlat: (ctx) => ctx.word === 'LETRIS' ? 30 : 0,
    coinFlat: (ctx) => ctx.word === 'LETRIS' ? 50 : 0 },

  { id: 'cascade-king', rarity: 'legendary', name: 'REY CASCADA', icon: '⛓', color: '#9B5DE5',
    desc: 'Auto-words por cascada: pts ×3',
    scoreMul: (ctx) => ctx.isAutoWord ? 3 : 1 },
];

// Power-ups (caja Mario Kart) — pool de slot machine
export const POWERUPS = [
  // ====== BUFFS (positivos, ~75% pool) ======
  { id: 'slow',     kind: 'buff', name: 'TIEMPO LENTO',  icon: '⏳', color: '#06D6A0', desc: 'Gravedad ×½ durante 25s' },
  { id: 'score2x',  kind: 'buff', name: 'PTS ×2',        icon: '✦', color: '#FFD166', desc: '3 palabras siguientes valen doble' },
  { id: 'clear',    kind: 'buff', name: 'LIMPIA FILA',   icon: '◢◤', color: '#06D6A0', desc: 'Borra la fila inferior del tablero' },
  { id: 'upgrade',  kind: 'buff', name: 'NIVEL UP',      icon: '↑', color: '#9B5DE5', desc: 'Sube +1 nivel un tile aleatorio' },
  { id: 'coins',    kind: 'buff', name: '+80 ◈',         icon: '◈', color: '#FFD166', desc: 'Lluvia de monedas instantánea' },
  { id: 'vowels',   kind: 'buff', name: 'VOCALES',       icon: 'AE', color: '#06D6A0', desc: 'Próximas 3 piezas son sólo vocales' },
  { id: 'rare-x3',  kind: 'buff', name: 'RARAS ×3',      icon: '★', color: '#C6F432', desc: 'Letras X/Z/K/J/Ñ ×3 pts (15s)' },
  // ====== DEBUFFS (~25% pool, riesgo del slot) ======
  { id: 'haste',    kind: 'debuff', name: 'PRISA',       icon: '⚡', color: '#EF476F', desc: 'Gravedad ×2 durante 15s' },
  { id: 'shuffle',  kind: 'debuff', name: 'CAOS',        icon: '↻', color: '#EF476F', desc: '5 tiles random cambian letra' },
];
